/*
 * angular-ui-bootstrap
 * http://angular-ui.github.io/bootstrap/

 * Version: 1.3.3 - 2016-05-22
 * License: MIT
 */
import CarouselSlideTemplate from 'text!./templates/slide.html';
import CarouselTemplate from 'text!./templates/carousel.html';

export default angular.module('ui.bootstrap.carousel', [])

    .controller('UibCarouselController', ['$scope', '$element', '$interval', '$timeout', '$animate', function ($scope, $element, $interval, $timeout, $animate) {
        const self = this;

        $scope.slides = [];
        self.slides = $scope.slides;
        const slides = self.slides;

        const SLIDE_DIRECTION = 'uibSlideDirection';
        let currentIndex = $scope.active;
        let currentInterval;
        let isPlaying;
        const bufferedTransitions = [];

        let destroyed = false;

        self.addSlide = function (slide, element) {
            angular.extend(slide, {
                index: slides.length
            });
            slides.push({
                slide: slide,
                element: element
            });
            slides.sort((a, b) => {
                return +a.slide.index - +b.slide.index;
            });
            // if this is the first slide or the slide is set to active, select it
            if (slide.index === $scope.active || (slides.length === 1 && !angular.isNumber($scope.active))) {
                if ($scope.$currentTransition) {
                    $scope.$currentTransition = null;
                }

                currentIndex = slide.index;
                $scope.active = slide.index;
                setActive(currentIndex);
                self.select(slides[findSlideIndex(slide)]);
                if (slides.length === 1) {
                    $scope.play();
                }
            }
        };

        self.getCurrentIndex = function () {
            for (let i = 0; i < slides.length; i++) {
                if (slides[i].slide.index === currentIndex) {
                    return i;
                }
            }
        };

        $scope.next = function () {
            const newIndex = (self.getCurrentIndex() + 1) % slides.length;

            if (newIndex === 0 && $scope.noWrap()) {
                $scope.pause();
                return;
            }

            return self.select(slides[newIndex], 'gw-carousel__slide_next');
        };
        self.next = $scope.next;

        $scope.prev = function () {
            const newIndex = self.getCurrentIndex() - 1 < 0 ? slides.length - 1 : self.getCurrentIndex() - 1;

            if ($scope.noWrap() && newIndex === slides.length - 1) {
                $scope.pause();
                return;
            }

            return self.select(slides[newIndex], 'gw-carousel__slide_prev');
        };
        self.prev = $scope.prev;

        self.removeSlide = function (slide) {
            const index = findSlideIndex(slide);

            const bufferedIndex = bufferedTransitions.indexOf(slides[index]);
            if (bufferedIndex !== -1) {
                bufferedTransitions.splice(bufferedIndex, 1);
            }

            // get the index of the slide inside the carousel
            slides.splice(index, 1);
            if (slides.length > 0 && currentIndex === index) {
                if (index >= slides.length) {
                    currentIndex = slides.length - 1;
                    $scope.active = currentIndex;
                    setActive(currentIndex);
                    self.select(slides[slides.length - 1]);
                } else {
                    currentIndex = index;
                    $scope.active = currentIndex;
                    setActive(currentIndex);
                    self.select(slides[index]);
                }
            } else if (currentIndex > index) {
                currentIndex--;
                $scope.active = currentIndex;
            }

            // clean the active value when no more slide
            if (slides.length === 0) {
                currentIndex = null;
                $scope.active = null;
                clearBufferedTransitions();
            }
        };

        /* direction: "prev" or "next" */
        $scope.select = function (nextSlide, direction) {
            const nextIndex = findSlideIndex(nextSlide.slide);
            // Decide direction if it's not given
            if (direction === undefined) {
                direction = nextIndex > self.getCurrentIndex() ? 'gw-carousel__slide_next' : 'gw-carousel__slide_prev';
            }
            // Prevent this user-triggered transition from occurring if there is already one in progress
            if (nextSlide.slide.index !== currentIndex && !$scope.$currentTransition) {
                goNext(nextSlide.slide, nextIndex, direction);
            } else if (nextSlide && nextSlide.slide.index !== currentIndex && $scope.$currentTransition) {
                bufferedTransitions.push(slides[nextIndex]);
            }
        };
        self.select = $scope.select;

        /* Allow outside people to call indexOf on slides array */
        $scope.indexOfSlide = function (slide) {
            return +slide.slide.index;
        };

        $scope.isActive = function (slide) { // Function could be invoked by parent scope - in which case we must find the right slide
            return $scope.active === slide.slide.index;
        };

        $scope.activeFn = $scope.isActive;

        $scope.isPrevDisabled = function () {
            return $scope.active === 0 && $scope.noWrap();
        };

        $scope.isNextDisabled = function () {
            return $scope.active === slides.length - 1 && $scope.noWrap();
        };

        $scope.pause = function () {
            if (!$scope.noPause) {
                isPlaying = false;
                resetTimer();
            }
        };

        $scope.play = function () {
            if (!isPlaying) {
                isPlaying = true;
                restartTimer();
            }
        };

        $scope.$on('$destroy', () => {
            destroyed = true;
            resetTimer();
        });

        $scope.$watch('noTransition', (noTransition) => {
            $animate.enabled($element, !noTransition);
        });

        $scope.$watch('interval', ()=> {
            restartTimer();
        });

        $scope.$watchCollection('slides', () => {
            resetTransition();
        });

        $scope.$watch('active', (index) => {
            if (angular.isNumber(index) && currentIndex !== index) {
                for (let i = 0; i < slides.length; i++) {
                    if (slides[i].slide.index === index) {
                        index = i;
                        break;
                    }
                }

                const slide = slides[index];
                if (slide) {
                    setActive(index);
                    self.select(slides[index]);
                    currentIndex = index;
                }
            }
        });

        function clearBufferedTransitions() {
            while (bufferedTransitions.length) {
                bufferedTransitions.shift();
            }
        }

        function setActive(index) {
            for (let i = 0; i < slides.length; i++) {
                slides[i].slide.active = i === index;
            }
        }

        function goNext(slide, index, direction) {
            if (destroyed) {
                return;
            }

            angular.extend(slide, {
                direction: direction
            });
            angular.extend(slides[currentIndex].slide || {}, {
                direction: direction
            });
            if ($animate.enabled($element) && !$scope.$currentTransition &&
                slides[index].element && self.slides.length > 1) {
                slides[index].element.data(SLIDE_DIRECTION, slide.direction);
                const currentIdx = self.getCurrentIndex();

                if (angular.isNumber(currentIdx) && slides[currentIdx].element) {
                    slides[currentIdx].element.data(SLIDE_DIRECTION, slide.direction);
                }

                $scope.$currentTransition = true;
                $animate.on('addClass', slides[index].element, (element, phase) => {
                    if (phase === 'close') {
                        $scope.$currentTransition = null;
                        $animate.off('addClass', element);
                        if (bufferedTransitions.length) {
                            const nextSlide = bufferedTransitions.pop().slide;
                            const nextIndex = nextSlide.index;
                            const nextDirection = nextIndex > self.getCurrentIndex() ? 'gw-carousel__slide_next' : 'gw-carousel__slide_prev';
                            clearBufferedTransitions();

                            goNext(nextSlide, nextIndex, nextDirection);
                        }
                    }
                });
            }

            $scope.active = slide.index;
            currentIndex = slide.index;
            setActive(index);

            // every time you change slides, reset the timer
            restartTimer();
        }

        function findSlideIndex(slide) {
            for (let i = 0; i < slides.length; i++) {
                if (slides[i].slide === slide) {
                    return i;
                }
            }
        }

        function resetTimer() {
            if (currentInterval) {
                $interval.cancel(currentInterval);
                currentInterval = null;
            }
        }

        function resetTransition(_slides) {
            if (!_slides.length) {
                $scope.$currentTransition = null;
                clearBufferedTransitions();
            }
        }

        function restartTimer() {
            resetTimer();
            const interval = +$scope.interval;
            if (!Number.isNaN(interval) && interval > 0) {
                currentInterval = $interval(timerFn, interval);
            }
        }

        function timerFn() {
            const interval = +$scope.interval;
            if (isPlaying && !Number.isNaN(interval) && interval > 0 && slides.length) {
                $scope.next();
            } else {
                $scope.pause();
            }
        }
    }])

    .directive('uibCarousel', () => {
        return {
            transclude: true,
            replace: true,
            controller: 'UibCarouselController',
            controllerAs: 'uibCarousel',
            template: function (element, attrs) {
                return attrs.template || CarouselTemplate;
            },
            scope: {
                active: '=?',
                interval: '=',
                noTransition: '=',
                noPause: '=',
                noWrap: '&',
                slides: '=',
                activeFn: '=' // To allow parent GW directive to use isActive()
            }
        };
    })

    .directive('gwCarouselSlide', () => {
        return {
            require: '^uibCarousel',
            transclude: true,
            replace: true,
            template: function (element, attrs) {
                return attrs.template || CarouselSlideTemplate;
            },
            scope: {
                actual: '=?'
            },
            link: function (scope, element, attrs, carouselCtrl) {
                carouselCtrl.addSlide(scope, element);
                // when the scope is destroyed then remove the slide from the current slides array
                scope.$on('$destroy', () => {
                    carouselCtrl.removeSlide(scope);
                });
            }
        };
    })

    .animation('.gw-carousel__slide', ['$animateCss',
        function ($animateCss) {
            const SLIDE_DIRECTION = 'uib-slideDirection';

            function removeClass(element, className, callback) {
                element.removeClass(className);
                if (callback) {
                    callback();
                }
            }

            return {
                beforeAddClass: function (element, className, done) {
                    if (className === 'gw-carousel__slide_active') {
                        const direction = element.data(SLIDE_DIRECTION);
                        const directionClass = direction === 'gw-carousel__slide_next' ? 'gw-carousel__slide_left' : 'gw-carousel__slide_right';
                        const removeClassFn = removeClass.bind(
                            this, element,
                            `${directionClass} ${direction}`, done
                        );
                        element.addClass(direction);

                        $animateCss(element, {
                            addClass: directionClass
                        })
                            .start()
                            .done(removeClassFn);

                        return () => {
                        };
                    }
                    done();
                },
                beforeRemoveClass: function (element, className, done) {
                    if (className === 'gw-carousel__slide_active') {
                        const direction = element.data(SLIDE_DIRECTION);
                        const directionClass = direction === 'gw-carousel__slide_next' ? 'gw-carousel__slide_left' : 'gw-carousel__slide_right';
                        const removeClassFn = removeClass.bind(this, element, directionClass, done);

                        $animateCss(element, {
                            addClass: directionClass
                        })
                            .start()
                            .done(removeClassFn);

                        return () => {
                        };
                    }
                    done();
                }
            };
        }
    ]);